var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { userApi } from 'api';
import { useApi, useToast } from 'hooks';
import { GAHandler } from 'utils/GA';
var useBuyContent = function () {
    var apiFetch = useApi().apiFetch;
    var me = userApi.useGetMe().data;
    var t = useTranslation().t;
    var toast = useToast().toast;
    var queryClient = useQueryClient();
    var url = (me === null || me === void 0 ? void 0 : me.features.flixx)
        ? '/payments/content'
        : '/payments/subscription/content';
    var buyContent = function (props) {
        var contentUuid = props.contentUuid, price = props.price;
        var data = (me === null || me === void 0 ? void 0 : me.features.flixx)
            ? {
                contentId: contentUuid,
                price: parseFloat(price),
            } : {
            uuid: contentUuid,
        };
        return apiFetch({
            url: url,
            method: 'POST',
            data: data,
        });
    };
    var _a = useMutation({
        mutationFn: buyContent,
        onSuccess: function (data, variables) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        GAHandler('content_buyed', {
                            contentUuid: variables.contentUuid,
                            seriesUuid: variables.seriesUuid,
                        });
                        // TODO: uncomment when backend fix the issue with isPurchesed in contents
                        // const uuid = variables.seriesUuid ?? variables.contentUuid
                        // await queryClient.invalidateQueries({ predicate: q => q.queryKey.includes(uuid) })
                        return [4 /*yield*/, queryClient.setQueryData(['purchases'], function (oldPurchases) {
                                if (!oldPurchases)
                                    return oldPurchases;
                                return __spreadArray(__spreadArray([], oldPurchases, true), [{ uuid: variables.contentUuid }], false);
                            })];
                    case 1:
                        // TODO: uncomment when backend fix the issue with isPurchesed in contents
                        // const uuid = variables.seriesUuid ?? variables.contentUuid
                        // await queryClient.invalidateQueries({ predicate: q => q.queryKey.includes(uuid) })
                        _a.sent();
                        return [4 /*yield*/, queryClient.setQueryData(['balance'], function (oldBalance) {
                                var newBalance = parseFloat(oldBalance) - parseFloat(variables.price);
                                return String(newBalance);
                            })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        onError: function (_, variables) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                GAHandler('content_buy_error', {
                    contentUuid: variables.contentUuid,
                    seriesUuid: variables.seriesUuid,
                });
                toast(t('anteroom:error.buyContent'), { icon: 'error' });
                return [2 /*return*/];
            });
        }); },
    }), mutateAsync = _a.mutateAsync, rest = __rest(_a, ["mutateAsync"]);
    return __assign({ buyContent: mutateAsync }, rest);
};
export default useBuyContent;
